/**
 * @module Section | Column Content Carousel - Editable
 * @description
 */
import ColumnContentCarousel from '~/blocks/ColumnContent/ColumnContentCarousel';
import { JsonObject, useMonarchSlotContext } from '@redventures/cohesion-utils-react';
import ColumnContentCarouselDefaults from '~/constants/ColumnContentCarouselDefaults';

interface Item {
  icon: string;
  heading: string;
  copy: string | JSX.Element;
}

interface Data extends JsonObject {
  heading: string;
  subheading: string;
  items: Item[];
}

const SectionColumnContentCarouselEditable = ( ) => {
  const { data } = useMonarchSlotContext<Data>();

  const {
    heading,
    subheading,
    items
  } = data ?? ColumnContentCarouselDefaults;

  return (
    <ColumnContentCarousel
      position='MONARCH'
      heading={ heading }
      subheading={ subheading }
      items={ items }
    />
  );
};

SectionColumnContentCarouselEditable.displayName = 'Section | Column Content Carousel - Editable';

export default SectionColumnContentCarouselEditable;
